export default "__VITE_ASSET__C8YXu09Y__"